import { Stack, Typography } from "@mui/material";
import type { WorkflowStatus } from "@entrilia/shared/api/workflowTypes";
import FieldsDiffTable from "@entrilia/shared/components/FieldsDiffTable";
import ShowMoreLessButton from "@entrilia/shared/components/ShowMoreLessButton";
import useToggleState from "@entrilia/shared/hooks/useToggleState";
import type { ChangeRequestChangeSet } from "../../../../api/types/workflowTypes";
import { formatChangeSetType, isChangeTypeWithNewValues } from "../changeRequestsFormatters";

interface Props {
  changeSet: ChangeRequestChangeSet;
  workflowStatus: WorkflowStatus;
}

const ChangeRequestDiffsSection = ({ changeSet, workflowStatus }: Props) => {
  const [expanded, toggleExpanded] = useToggleState(false);

  const oldValueColumnLabel = isChangeTypeWithNewValues(changeSet.changeSetType)
    ? undefined
    : workflowStatus === "Completed"
      ? "Old"
      : "Current";

  const newValueColumnLabel = isChangeTypeWithNewValues(changeSet.changeSetType) ? "New" : "Change";

  const isExpandable = changeSet.changeSetType === "FundInvestorBankAccountAssignment";

  const title = changeSet.displayName ? changeSet.displayName : formatChangeSetType(changeSet.changeSetType);
  const subtitle = changeSet.displayName ? formatChangeSetType(changeSet.changeSetType) : "";

  return (
    <Stack spacing={1} sx={{ alignItems: "flex-start", width: "100%" }}>
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Stack spacing={0.5}>
          <Typography variant="subtitle2">{title}</Typography>
          {subtitle && (
            <Typography variant="caption" color="textSecondary">
              {subtitle}
            </Typography>
          )}
        </Stack>
        <FieldsDiffTable
          fieldChanges={!isExpandable || expanded ? changeSet.fieldChanges : changeSet.fieldChanges.slice(0, 1)}
          oldValueColumnLabel={oldValueColumnLabel}
          newValueColumnLabel={newValueColumnLabel}
        />
      </Stack>
      {isExpandable && <ShowMoreLessButton expanded={expanded} onClick={() => toggleExpanded()} />}
    </Stack>
  );
};

export default ChangeRequestDiffsSection;
